import { computed } from "vue";
import { useAuthStore } from "@/store/authstore";
import { useInvoiceStore } from "@/store/invoicestore";
import { useExpenseStore } from "@/store/expensestore";
import { FREE_TIER_LIMIT } from "@/utils/freeTier";

export function useFreeTierStatus() {
  const authStore = useAuthStore();
  const invoiceStore = useInvoiceStore();
  const expenseStore = useExpenseStore();

  const hasAccess = computed(() => !!authStore.user?.hasAccess);
  const totalItems = computed(
    () => (invoiceStore.invoiceCount ?? 0) + (expenseStore.expenseCount ?? 0)
  );
  const limitReached = computed(() => !hasAccess.value && totalItems.value >= FREE_TIER_LIMIT);

  async function ensureCounts() {
    if (!authStore.user || hasAccess.value) return;
    await Promise.all([invoiceStore.fetchInvoiceCount(), expenseStore.fetchExpenseCount()]);
  }

  return { hasAccess, totalItems, limitReached, ensureCounts, FREE_TIER_LIMIT };
}
